var _style, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 33",
    width: 50,
    height: 33,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#4ca084}.b{fill:#488bc9}.c{fill:#5cb99f}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m50 16.3c0 4.5-1.8 8.5-4.8 11.5l4.8 4.7h-16.4c-3.2 0-6.1-0.8-8.6-2.4 4.7-2.8 7.8-8 7.8-13.8 0-5.9-3.1-11-7.8-13.9 2.5-1.5 5.4-2.4 8.6-2.4 9.1 0 16.4 7.3 16.4 16.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m17.2 16.3c0 5.9 3.1 11 7.8 13.8-2.5 1.6-5.4 2.5-8.6 2.5-9.1 0-16.4-7.3-16.4-16.3 0-9 7.3-16.3 16.4-16.3 3.2 0 6.1 0.9 8.6 2.4-4.7 2.9-7.8 8-7.8 13.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m32.8 16.3c0 5.8-3.1 11-7.8 13.8-4.7-2.8-7.8-8-7.8-13.8 0-5.9 3.1-11 7.8-13.9 4.7 2.9 7.8 8 7.8 13.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3bc4901c2899b71280e6ffe33a0f54a0.svg";
export { ForwardRef as ReactComponent };